module.exports = __webpack_public_path__ + "static/media/exchangeGames-lines.29503b01.svg";